import Vue from 'vue';
import ElementUI from 'element-ui';
import axios from 'axios';
import api from './api/api';
import store from './store/store';

const loginWeb = api.login_web;

Vue.prototype.$http = axios;
Vue.use(ElementUI);
// import router from './router';
axios.interceptors.request.use(
  (config) => {
    const myConfig = config;
    store.commit('changeLoading', true);
    if (api.getQueryString('auth_code')) {
      localStorage.setItem('token', api.getQueryString('auth_code'));
      location.href = '/';
    }
    const xtoken = localStorage.getItem('token');
    if (xtoken !== null) {
      myConfig.headers['X-Token'] = xtoken;
    }
    if (
      config.method === 'post' ||
      config.method === 'put' ||
      config.method === 'delete'
    ) {
      if (
        typeof config.data !== 'string' &&
        config.headers['Content-Type'] !== 'multipart/form-data'
      ) {
        myConfig.data = {
          ...config.data,
        };
      }
    } else if (config.method === 'get') {
      myConfig.params = {
        ...config.params,
      };
    }
    return myConfig;
  },
  error => Promise.reject(error),
);
axios.interceptors.response.use(
  (response) => {
    store.commit('changeLoading', false);
    if (response.data.ret === 2) {
      localStorage.clear();
      Vue.prototype.$alert('请重新登录~', '提示', {
        confirmButtonText: '确定',
        callback: () => {
          location.href = loginWeb;
        },
      });
    } else if (response.data.ret === 1) {
      Vue.prototype.$message.error('服务器错误~');
    } else if (response.data.ret === -1) {
      Vue.prototype.$message.error('单点登录超时~');
    }
    return response;
  },
  (error) => {
    Vue.prototype.$message.error(error);
    return Promise.reject(error);
  },
);



// WEBPACK FOOTER //
// ./src/permission.js